import { Injectable } from '@angular/core';
import { TableCol } from '@app/interface/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TrackParticipantService {
  tableColums$: BehaviorSubject<TableCol[]> = new BehaviorSubject<TableCol[]>([]);
  constructor() {}
}
